'use strict';

angular.module('utils').factory('OCWelcomeModalUtil', function(OCModalUtil, localStorageService) {
  return {
    checkWelcomeModal: function() {
      if (!localStorageService.get('visited 2.0')) {
        localStorageService.set('visited 2.0', true);

        OCModalUtil.showCustomModal({
          templateUrl: '/views/modals/_user-welcome.html',
          controller: 'ModalGenericSaveClose',
        });
      }
    },
  };
});
